export default __webpack_public_path__ + "static/media/ecolums-web1.1fab9930.jpg";